<template>
    <div id="aprication">
        <div class="header-div">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="header-div" style="text-align: right">
            <el-button size="mini" @click="batchDownLoad()" style=";background-color:#ffa700;color: white">批量下载<i
                    class="el-icon-download"></i></el-button>
            <el-button size="mini" @click="handleEdit()" style=";background-color:#16E3A1;color: white">生成策略<i
                    class="el-icon-document-copy"></i></el-button>
        </div>
        <el-table
                :data="tableData"
                size="medium"
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="selectionLineChangeHandle"
        >
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column prop="tableName" label="表名称" style="width: 20%"></el-table-column>
            <el-table-column prop="engine" label="engine" style="width: 20%"></el-table-column>
            <el-table-column prop="tableComment" label="表描述" style="width: 20%"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" style="width: 20%"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleDownLoad(scope.$index, scope.row)">下载<i
                            class="el-icon-download"></i></el-button>
                </template>
            </el-table-column>
        </el-table>
        <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
    </div>
</template>
<script>
    import Edit from './edit'

    export default {
        name: 'GeneratorList',
        components: {
            Edit
        },
        data() {
            return {
                tableData: [],
                dataOnLineListSelections: [],
                editVisible: false
            }
        },
        methods: {
            handleCurrentChange() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/common/generator/list'),
                    method: 'get'
                }).then(r => {
                    this.tableData = r.data.data;
                }).finally(r => {
                })
            },
            handleEdit() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int();
                })
            },
            handleDownLoad(index, row) {
                let tableName = row.tableName;
                let url = process.env.VUE_APP_SERVER_URL + "/business/common/generator/code";
                let form = $("<form></form>").attr("action", url).attr("method", "post").attr("target", "_blank");
                var input = "<input type = 'hidden' name = 'tableName' value = '" + tableName + "'/>";
                form.append(input);
                form.appendTo('body').submit().remove();
            },
            batchDownLoad() {
                if (this.dataOnLineListSelections.length == 0) {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "请选择数据"
                    })
                    return false;
                }
                let ids = [];
                for (var i = 0; i < this.dataOnLineListSelections.length; i++) {
                    ids.push(this.dataOnLineListSelections[i].tableName);
                }
                let url = process.env.VUE_APP_SERVER_URL + "/business/common/generator/batchCode";
                let form = $("<form></form>").attr("action", url).attr("method", "post").attr("target", "_blank");
                var input = "<input type = 'hidden' name = 'tables' value = '" + ids.toString() + "' />";
                form.append(input);
                form.appendTo('body').submit().remove();
            },
            selectionLineChangeHandle(val) {
                this.dataOnLineListSelections = val;
            }
        },
        created: function () {
            this.handleCurrentChange();
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 10px;
        float: left;
        width: 50%;
    }
</style>
